export const getCustomBreakdown = (details) => {
  const breakdown =  details.reduce((prev, detail) => {
    const detail_breakdown = detail?.misc?.breakdown;
    if(detail_breakdown){
        for(let entry of detail_breakdown){
            prev[entry?.key] = { ...entry, value: (entry.value || 0) + (prev[entry?.key]?.value || 0)}
        }
    }
    return prev;
  }, {});

  return Object.values(breakdown)
}
